import { useState } from 'react';

const useInputValue = (initialState = undefined) => {
  return useState(initialState);
};

export default useInputValue;
